import React from 'react';
import { AlertTriangle, PauseCircle, ShieldCheck, ShieldOff } from 'lucide-react';

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
const BRAND = { probound: 'ProBound', proepoxy: 'ProEpoxy', prodecor: 'ProDecor' };

export const STATUS = {
  ok: { label: 'Active', cls: 'bg-emerald-100 text-emerald-800', Icon: ShieldCheck },
  at_risk: { label: 'At risk', cls: 'bg-amber-100 text-amber-800', Icon: AlertTriangle },
  final: { label: 'Final notice', cls: 'bg-orange-100 text-orange-800', Icon: AlertTriangle },
  lapsed: { label: 'Lapsed', cls: 'bg-red-100 text-red-800', Icon: ShieldOff },
  exempt: { label: 'Exempt', cls: 'bg-sky-100 text-sky-800', Icon: PauseCircle },
};

export function StatusPill({ status, testId }) {
  const s = STATUS[status] || STATUS.ok;
  return <span className={`inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${s.cls}`} data-testid={testId}><s.Icon className="w-3 h-3" /> {s.label}</span>;
}

export function ActivityTable({ rows, cfg, onOpen }) {
  if (!rows.length) return <div className="p-8 text-center text-sm text-gray-500" data-testid="aa-empty">Nobody in this list.</div>;
  return (
    <div className="table-scroll"><table className="w-full text-sm" data-testid="aa-table">
      <thead className="bg-gray-50 text-[11px] uppercase tracking-wider text-gray-500"><tr>
        <th className="text-left px-3 py-2">Installer</th><th className="text-left px-3 py-2">Status</th><th className="text-left px-3 py-2">Last order</th><th className="text-right px-3 py-2">Inactive</th><th className="text-right px-3 py-2">90d leads → orders</th><th className="text-left px-3 py-2 hidden md:table-cell">Plan</th><th className="text-left px-3 py-2 hidden lg:table-cell">Last contact</th>
      </tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.user_id} onClick={() => onOpen(r)} className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer" data-testid={`aa-row-${r.user_id}`}>
            <td className="px-3 py-2"><div className="font-semibold text-gray-900">{r.company_name || r.name}</div><div className="text-xs text-gray-500">{r.name} · {r.brands.map((b) => BRAND[b]).join(', ')}</div></td>
            <td className="px-3 py-2"><StatusPill status={r.status} /></td>
            <td className="px-3 py-2 text-gray-700">{fmtDate(r.last_order_at)}{r.last_order_brand && <div className="text-[11px] text-gray-400">{BRAND[r.last_order_brand]}</div>}</td>
            <td className={`px-3 py-2 text-right font-bold ${r.days_inactive >= cfg.final_days ? 'text-red-700' : r.days_inactive >= cfg.warn_days ? 'text-amber-700' : 'text-gray-900'}`}>{r.days_inactive}d</td>
            <td className="px-3 py-2 text-right"><span className={r.ratio_ok ? 'text-gray-700' : 'text-orange-700 font-bold'}>{r.leads_90d} → {r.orders_90d}</span>{!r.ratio_ok && <div className="text-[11px] text-orange-600">expected {r.expected_orders}</div>}</td>
            <td className="px-3 py-2 text-xs text-gray-600 hidden md:table-cell">{r.subscription?.label || '—'}</td>
            <td className="px-3 py-2 text-xs text-gray-600 hidden lg:table-cell">{r.last_contact_at ? <>{fmtDate(r.last_contact_at)}{r.next_follow_up && <div className="text-[11px] text-sky-700">follow up {fmtDate(r.next_follow_up)}</div>}</> : 'Never'}</td>
          </tr>
        ))}
      </tbody>
    </table></div>
  );
}
